<template>
  <lytable :tableData="items" :columns="columns"> </lytable>
</template>
<script>
import lytable from "../lytable.vue";
export default {
  components: { lytable },
  data() {
    return {
      items: [
        {
          carNo: "粤A5462",
          alarmType: "断电报警",
          alarmTime2: "2023-04-06 12:14",
        },
        {
          carNo: "粤A5462",
          alarmType: "断电报警",
          alarmTime2: "2023-04-06 12:14",
        },
      ],
      searchItem: {
        endTime: "",
        pageNumber: 1,
        pageSize: 12,
        sort: 2,
        startTime: "",
      },
      columns: [
        {
          title: "车牌号",
          key: "carNo",
        },
        {
          title: "报警类型",
          key: "alarmType",
        },
        {
          title: "报警时间",
          key: "alarmTime2",
        },
      ],
      //http://120.25.144.155:8001/gps-d?carld=3630#/login
      //http://120.25.144.155:8001/gps-d?carld=3630
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start;
      this.searchItem.endTime = v.end;
      this.getData();
    },
     groups(v){
      this.searchItem.groupIdList=[];
      for (let i = 0; i < v.length; i++) {
       this.searchItem.groupIdList.push(v[i].id);
        
      }
      this.getData();
    },
    getData() {
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-rmm-server-rpt/count/countAlarm",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        console.log(res);
        for (let i = 0; i < data.length; i++) {
         data[i].alarmTime2=this.utils.time(data[i].alarmTime)
          
        }
        this.items = data;
      });
    },
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/cheliangbaojing.vue